import CarrerSlider from "./Slider";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import HelpCenter from "../reusble_components/helpCenter";

export default function CareerLanding() {
  const { CommonStore, UserStore } = useStores();
  const navigate = useNavigate();
  const checkProfileDetails = () => {
    UserStore.getUserDetails();
    try {
      const data = {
        name: UserStore.userDetails.name,
        college: UserStore.userDetails.college,

        linkedin: UserStore.userDetails.linkedIn,
        skills: UserStore.userDetails.skills,
        designation: UserStore.userDetails.designation,
        gender: UserStore.userDetails.gender,
        cityPreference: UserStore.userDetails.cityPreference,
        workPreference: UserStore.userDetails.workPreference,
        lookingFor: UserStore.userDetails.lookingFor,
      };

      const missingProperties = Object.keys(data).filter((key) => !data[key]);

      if (missingProperties.length > 0) {
        alert(
          "Please fill in the following profile details: " +
            missingProperties.join(", ") +
            " in the profile section."
        );
        const confirmFillProfile = window.confirm(
          "  Do you want to update profile section now?"
        );

        if (confirmFillProfile) {
          navigate("/dashboard/settings");
          return;
        }
        return;
      }

      if (UserStore.userDetails.resume === null) {
        // Display an alert first
        alert("Please upload your resume in the profile section.");

        // Then ask for confirmation
        const confirmFillProfile = window.confirm(
          "Do you want to update the profile section now?"
        );

        if (confirmFillProfile) {
          navigate("/dashboard/settings");
          return;
        }
        return; // This return statement is redundant; you can remove it
      }

      console.log(data);
      navigate("/dashboard/career-details");
    } catch (error) {
      alert("Please fill your profile details");
      navigate("/dashboard/settings");
    }
  };

  return (
    <div className="md:grid md:grid-cols-2 mt-40 md:mt-0">
      <HelpCenter />
      <div className="flex flex-col md:hidden gap-10 h-[100%] justify-center  px-8 mt-6 ">
        <h1 className="font-bold text-4xl">
          Apply for <span className="text-primary">Job/internship</span>
        </h1>
        <p className=" text-lg">
          Introducing 'Careers' in Reaidy: Apply for jobs and internships
          effortlessly. Our platform handles screening and interviews for faster
          hiring.
        </p>
        <button
          className="px-5 py-4 bg-primary w-40 rounded-lg text-white font-bold"
          onClick={() => {
            console.log("clicked");
            CommonStore.setBottomNavigationIndex(9);
            console.log(CommonStore.bottomNavigationIndex);
          }}>
          Get Started
        </button>
      </div>
      <div className="flex flex-col justify-between items-center">
        {/* <img src={carrer_img} alt="career" className="career_img" /> */}
        <CarrerSlider />
      </div>
      <div className="flex flex-col md:hidden gap-10 h-[100%] justify-center  px-20 my-6 py-20">
        {/* <p className="text-primary text-lg font-bold flex gap-2 items-center ">
          View past applications <AiOutlineRightCircle></AiOutlineRightCircle>
        </p> */}
      </div>
      <div className="hidden md:flex md:flex-col gap-10 h-[100%] justify-center  px-20 mt-6 ">
        <h1 className="font-bold text-4xl">
          Apply for <span className="text-primary">Job/internship</span>
        </h1>
        <p className="">
          Introducing 'Careers' in Reaidy: Apply for jobs and internships
          effortlessly. Our platform handles screening and interviews for faster
          hiring.
        </p>
        <button
          className="px-5 py-4 bg-primary w-40 rounded-lg text-white font-bold"
          onClick={() => {
            checkProfileDetails();
            // navigate("/dashboard/career-details");
          }}>
          Get Started
        </button>
        {/* <p className="text-primary text-lg font-bold flex gap-2 items-center ">
          View past applications <AiOutlineRightCircle></AiOutlineRightCircle>
        </p> */}
      </div>
    </div>
  );
}
